import React, { useContext } from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';

import { AuthProvider, AuthContext } from './context/AuthContext';
import LoginForm from './components/LoginForm';
import Dashboard from './pages/Dashboard';
import Pacientes from './pages/Pacientes';
import Calendario from './pages/Calendario';
import Facturacion from './pages/Facturacion';
import HistorialPaciente from './pages/HistorialPaciente';
import HistorialClinico from './pages/HistorialClinico';
import HistorialEconomico from './pages/HistorialEconomico';
import Presupuesto from './pages/Presupuesto';
import FacturacionGeneral from './pages/FacturacionGeneral';
import Odontograma from './pages/Odontograma';
import ImagenesPaciente from './pages/ImagenesPaciente';
import Auditoria from './pages/Auditoria';
import DocumentosPaciente from './pages/DocumentosPaciente';
import Tratamientos from './pages/Tratamientos';
import Topbar from './components/Topbar';
import FirmaDocumentoPublica from "./pages/FirmaDocumentoPublica";
import FormularioPublico from "./pages/FormularioPublico";
import FirmaProteccionDatos from './pages/FirmaProteccionDatos';
import RecallsDashboard from './pages/RecallsDashboard'; 
import HistorialPresupuestos from './pages/HistorialPresupuestos';
import HistorialFacturas from './pages/HistorialFacturas';

import './styles/base.css';
import './styles/layout.css';
import './styles/Topbar.css';

function PrivateRoute({ component: Component, ...rest }) {
  const { token } = useContext(AuthContext);

  return (
    <Route
      {...rest}
      render={(props) =>
        token ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );
}

function RoleRoute({ allowedRoles, children, ...rest }) {
  const { roles } = useContext(AuthContext);
  const hasAccess = roles.some(r => allowedRoles.includes(r));
  const token = localStorage.getItem("token");

  return (
    <Route
      {...rest}
      render={() =>
        hasAccess ? children : <Redirect to="/dashboard" />
      }
    />
  );
}

function PrivateLayout({ children }) {
  return (
    <div className="app-layout">
      <Topbar />
      <main className="app-content">
        {children}
      </main>
    </div>
  );
}

function PrivateWrapper() {
  return (
    <PrivateLayout>
      <Switch>

        <Route path="/dashboard" component={Dashboard} />

        <Route exact path="/pacientes" component={Pacientes} />
        <Route exact path="/pacientes/nuevo">
          <HistorialPaciente isNew />
        </Route>

        <Route path="/pacientes/:expediente/historial-clinico/odontograma">
          <Odontograma />
        </Route>

        <Route exact path="/pacientes/:expediente/historial-clinico">
          <HistorialClinico />
        </Route>

        <Route path="/pacientes/:expediente/historial-economico">
          <HistorialEconomico />
        </Route>

        <Route path="/pacientes/:expediente/historial-presupuestos">
            <HistorialPresupuestos />
        </Route>

        <Route path="/pacientes/:expediente/historial-facturas">
            <HistorialFacturas />
        </Route>
        
        <Route path="/pacientes/:expediente/imagenes">
          <ImagenesPaciente />
        </Route>

        <Route path="/pacientes/:expediente/documentos">
          <DocumentosPaciente />
        </Route>

        <Route exact path="/pacientes/:expediente">
          <HistorialPaciente />
        </Route>

        <Route path="/presupuesto" component={Presupuesto} />

        <Route path="/calendario" component={Calendario} />

        <RoleRoute
          path="/facturacion/general"
          allowedRoles={['ADMIN', 'ODONTOLOGO']}
        >
          <FacturacionGeneral />
        </RoleRoute>

        <Route path="/facturacion" component={Facturacion} />

        <Route path="/tratamientos" component={Tratamientos} />

        <Route path="/recalls" component={RecallsDashboard} />
        <RoleRoute
          path="/auditoria"
          allowedRoles={['ADMIN', 'ODONTOLOGO']}
        >
          <Auditoria />
        </RoleRoute>

        <Redirect from="*" to="/dashboard" />

      </Switch>
    </PrivateLayout>
  );
}


export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Switch>
          <Route exact path="/">
            <Redirect to="/login" />
          </Route>
          {/* PUBLIC */}
          <Route path="/login" component={LoginForm} />
          <Route path="/firma/:token" component={FirmaDocumentoPublica} />
          <Route path="/formulario-publico" component={FormularioPublico} />
          <Route path="/firma-rgpd/:token" component={FirmaProteccionDatos} />

          {/* PRIVATE */}
          <PrivateRoute path="/" component={PrivateWrapper}/>
            
        </Switch>
      </BrowserRouter>
    </AuthProvider>
  );
}

